import './icp.scss';

import rhinoCore from 'rhino/src/core/core.module';

import * as stIcpDirective from './icp.directive';

export default angular.module('start.components.icp', [
  rhinoCore,
])
  .directive(stIcpDirective.name, stIcpDirective.default)
  .name;



// WEBPACK FOOTER //
// ./components/icp/icp.module.js